/* eslint-disable require-jsdoc */
import AemGrid from "@/components/AemGrid"
import BreadCrumb from "@/components/Default/BreadCrumb"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageLayout from "@/components/Shared/GlobalPage/GlobalPageLayout"
import {
  footerUrl,
  headerUrl,
  previewContentPrefix,
} from "@/constants"
import { aemAxiosInstance, aemPreviewAxiosInstance } from "@/constants/api"
import { filterBackEndJson } from "@/utils/helper"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"

const Blog = ({
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  globalScript,
  footerScript,
  analysticsScript,
}) => {
  return (
    <GlobalPageLayout
      header={
        <GlobalPageHeader
          header={header}
          title={data.title}
          globalScripting={globalScript}
          analysticsScript={analysticsScript}
        />
      }
      footer={<GlobalPageFooter footer={footer} footerScripting={footerScript} />}
    >
      <div className="min-vh-100" style={{ background: "transparent" }}>
        <AemGrid
          data={data}
          count={0}
          breadCrumb={(data, fullData) => (
            <BreadCrumb data={data} fullData={fullData} />
          )}
        />
      </div>
    </GlobalPageLayout>
  )
}
export async function getServerSideProps({ req, query, locale }) {
  const isPreviewMode = req.cookies["aem-author-preview-mode"]
  let action = "blog"
  if ("blog" in query) {
    action += `/${query.blog[0]}`
  }

  const { data } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${previewContentPrefix}/${action}.model.json`,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: `${previewContentPrefix}/${action}.model.json`,
        method: "GET",
      })

  const { data: header } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })

  const { data: footer } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
  const globalScript = data?.globalScript ? data.globalScript : null
  const footerScript = data?.footerScript ? data.footerScript : null

  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  const analysticsScript = data?.adobeAnalytic || null
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  return {
    props: {
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      analysticsScript,

      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}
export default Blog
